var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMaintenance = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 159,
    viewBox: "0 0 128 159",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 15.474L86.4525 49.0832H47.5475L67 15.474ZM67 5.1665L38.5833 54.2498H95.4166L67 5.1665ZM69.5833 41.3332H64.4166V46.4998H69.5833V41.3332ZM69.5833 25.8332H64.4166V36.1665H69.5833V25.8332Z",
    fill: "#F43E3E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8047_42272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2875 127C31.4167 127 26.6666 131.8 26.6666 137.667C26.6666 143.533 31.4167 148.333 37.2875 148.333C43.1584 148.333 47.9618 143.533 47.9618 137.667C47.9618 131.8 43.1584 127 37.2875 127ZM90.659 127C84.7881 127 80.0381 131.8 80.0381 137.667C80.0381 143.533 84.7881 148.333 90.659 148.333C96.5299 148.333 101.333 143.533 101.333 137.667C101.333 131.8 96.5299 127 90.659 127Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6666 137.667C42.6666 140.612 40.2788 143 37.3333 143C34.3878 143 31.9999 140.612 31.9999 137.667C31.9999 134.721 34.3878 132.333 37.3333 132.333C40.2788 132.333 42.6666 134.721 42.6666 137.667Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9999 137.667C95.9999 140.612 93.6121 143 90.6666 143C87.7211 143 85.3333 140.612 85.3333 137.667C85.3333 134.721 87.7211 132.333 90.6666 132.333C93.6121 132.333 95.9999 134.721 95.9999 137.667Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.24 109.667L38.4 109.027L43.2 100.333H82.9333C86.9333 100.333 90.4533 98.1465 92.2666 94.8398L112.853 57.4532L103.573 52.3332H103.52L97.6533 62.9998L82.9333 89.6665H45.4933L44.8 88.2265L32.8533 62.9998L27.7866 52.3332L22.7733 41.6665H5.33331V52.3332H16L35.2 92.8132L28 105.88C27.1466 107.373 26.6666 109.133 26.6666 111C26.6666 116.867 31.4666 121.667 37.3333 121.667H101.333V111H39.5733C38.88 111 38.24 110.413 38.24 109.667Z",
    fill: "#FFD600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8047_42272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 31)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMaintenance, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Maintenance.8d9ab300.svg";
export { ForwardRef as ReactComponent };